<template>
    <div><LocationSelector :locations="locations" :value="value.locations" @input="updateLocations" /></div>
</template>

<script>
import LocationSelector from './common/LocationSelector.vue';
import { createUpdaters } from '../widgetHelpers';

export default {
    components: { LocationSelector },

    props: {
        locations: {
            type: Array,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },
    },

    methods: createUpdaters('locations'),
};
</script>
